import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { FactSample } from '@/modules/analysis/models/analysisRequest';
export interface SampleBatchStatusRequest {
  status: { id: string; facts: FactSample[] }[];
}

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.samples}`;

export function updateStatus(statusBody: SampleBatchStatusRequest): AxiosPromise<void> {
  return axios.patch(`${resourceEndpoint}/status`, statusBody, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
